import { integrationLinksList } from "@/app/Settings/Settings/GraphQL/integrationLinksQueries";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { CellContext } from "@/lib/Components/DataTable/types";
import { ModelType } from "@/gql/graphql";
import { useIntegrationRecord } from "@/app/Settings/Settings/Hooks/useIntegrationRecord";
import { useJucyOfficeCodesList } from "@/app/Settings/Integrations/Jucy/Hooks/useJucyCodesList";
import { Suspense, useState } from "react";
import { upsertIntegrationLink } from "@/app/Settings/Settings/GraphQL/integrationLinkMutations";
import { QueryClient } from "@/lib/ReactQuery/QueryClient";
import { Select } from "@/components/catalyst/select";
import { Skeleton } from "@/components/ui/skeleton";
import { SupplierOfficeListItem } from "@/app/Offices/GraphQL/supplierOfficeListQuery";

export function JucyOfficeCodeCell(
  props: CellContext<SupplierOfficeListItem, any>,
) {
  return (
    <Suspense fallback={<Skeleton className="h-9 w-[356px]" />}>
      <CellInner {...props} />
    </Suspense>
  );
}

function CellInner({ row }: CellContext<SupplierOfficeListItem, any>) {
  const jucyIntegration = useIntegrationRecord();

  const integrationLinks = useSuspenseGqlQuery(integrationLinksList, {
    integration_id: jucyIntegration.id,
  });

  const integrationLink = integrationLinks.data?.integrationLinks.data.find(
    (item) => {
      return (
        item.object_type === ModelType.SupplierOffice &&
        item.object_id === row.original.id
      );
    },
  );

  const { data } = useJucyOfficeCodesList();

  const offices =
    data
      ?.filter((office) => {
        return office.countryCode === jucyIntegration.metadata.region;
      })
      .map((office) => {
        return {
          label: office.siteCode,
          value: office.siteCode,
        };
      }) ?? [];

  const [externalId, setExternalId] = useState<string>(
    integrationLink?.external_id ?? "",
  );

  const { mutateAsync } = useGqlMutation(upsertIntegrationLink, {
    onSuccess: () => {
      return QueryClient.invalidateQueries();
    },
  });

  return (
    <Select
      value={externalId}
      onChange={async (e) => {
        setExternalId(e.target.value);
        await mutateAsync({
          id: integrationLink?.id,
          input: {
            external_id: e.target.value,
            object: {
              connect: {
                id: row.original.id,
                type: ModelType.SupplierOffice,
              },
            },
            integration: {
              connect: jucyIntegration.id,
            },
          },
        });
      }}
    >
      <option value="" disabled>
        Select an office
      </option>
      {offices.map((externalId) => (
        <option key={externalId.value} value={externalId.value}>
          {externalId.label}
        </option>
      ))}
    </Select>
  );
}
